import { fromJS } from 'immutable';
import {
    GET_CURRENT_USER_REQUEST,
    GET_CURRENT_USER_SUCCESS,
    GET_CURRENT_USER_FAILURE,
} from './actions';

const initialState = fromJS({
    loadingGetCurrentUser: false,
    dataGetCurrentUser: null,
    errorGetCurrentUser: null,
});

const CurrentUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_USER_REQUEST:
            return state.set('loadingGetCurrentUser', true);
        case GET_CURRENT_USER_SUCCESS:
            return state
                .set('loadingGetCurrentUser', false)
                .set('dataGetCurrentUser', action.payload);
        case GET_CURRENT_USER_FAILURE:
            return state
                .set('loadingGetCurrentUser', false)
                .set('errorGetCurrentUser', action.error);
        default:
            return state;
    }
};

export default CurrentUserReducer;
